export const AUTHORING_RIGHT_BAR_WIDTH = 520
export const AUTHORING_RIGHT_BAR_MIN_WIDTH = 420
export const AUTHORING_RIGHT_BAR_MAX_WIDTH = "36vw"

export const DEFAULT_RIGHT_BAR_WIDTH = 500
export const DEFAULT_RIGHT_BAR_MIN_WIDTH = 320
export const DEFAULT_RIGHT_BAR_MAX_WIDTH = "27vw"

export function resolveScheduleRightBarMode({ isAuthoringScheduleEditor, onePage }) {
    const usesInlineRightBar = !!onePage && !isAuthoringScheduleEditor
    return {
        usesInlineRightBar,
        usesSideRightBar: !usesInlineRightBar,
    }
}

export function resolveScheduleViewModes({ isAuthoringScheduleEditor }) {
    if (isAuthoringScheduleEditor) {
        return [
            { label: "Compact", showDetail: false, onePage: false },
            { label: "Expanded", showDetail: true, onePage: false },
        ]
    }

    return [
        { label: "Compact", showDetail: false, onePage: false },
        { label: "Expanded", showDetail: true, onePage: false },
        { label: "One Page Compact", showDetail: false, onePage: true },
        { label: "One Page Expanded", showDetail: true, onePage: true },
    ]
}

export function resolveScheduleViewModeLabel({ isAuthoringScheduleEditor, onePage, showDetail }) {
    const effectiveOnePage = !!onePage && !isAuthoringScheduleEditor
    return showDetail
        ? effectiveOnePage
            ? "One Page Expanded"
            : "Expanded"
        : effectiveOnePage
          ? "One Page Compact"
          : "Compact"
}

export function resolveScheduleRightBarWidth({ isAuthoringScheduleEditor }) {
    if (isAuthoringScheduleEditor) {
        return {
            maxWidth: AUTHORING_RIGHT_BAR_MAX_WIDTH,
            minWidth: AUTHORING_RIGHT_BAR_MIN_WIDTH,
            width: AUTHORING_RIGHT_BAR_WIDTH,
        }
    }

    return {
        maxWidth: DEFAULT_RIGHT_BAR_MAX_WIDTH,
        minWidth: DEFAULT_RIGHT_BAR_MIN_WIDTH,
        width: DEFAULT_RIGHT_BAR_WIDTH,
    }
}
